import React from "react";
import Style from "types/globals/styleguide/style";
import StyleDataSet from "types/globals/styleguide/styleDataSet";
import StyleguideData from "types/globals/styleguide/styleguideData";
import TypographicDataSet from "types/globals/styleguide/typographicDataSet";

import getColors from "../getColors";

const createCSSColor = (styleguide: StyleguideData, className: string, reference: string) => {
    const style = `
        .`+className+` {
            color: `+getColors(styleguide.colors, reference)+`
        }
    `
    return style
}

export default createCSSColor